import { EventEmitter, Injectable, Output } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs/';
import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService } from 'lib/ng2-sapmp/src/providers/http-client.service';
import { UtilityService } from 'lib/ng2-sapmp/src/providers/utility.service';
import { AuthenticationService } from 'lib/ng2-sapmp/src/providers/authentication.service';
import { CMSResolver } from 'lib/ng2-sapmp/src/providers/cms.resolver';
import { Router } from '@angular/router';
import { PERMISSION } from 'config';
// import { BehaviorSubject } from 'rxjs/BehaviorSubject';


declare var ENV_PORTAL;
declare var logoutHeaderChange;
declare var ADMIN_LOGOUT;

@Injectable()
export class HeaderService {
  private pageStatus = new BehaviorSubject<boolean>(false);
  public obvStep: Observable<boolean> = this.pageStatus.asObservable(); // convert to Observable for subscribing

  private logoutHeaderChanges = new BehaviorSubject<any>(false);
  public logoutHeaderChangesSteps: Observable<boolean> = this.logoutHeaderChanges.asObservable();

  private hideMenu = new BehaviorSubject<any>(false);
  public hideMenuSteps: Observable<boolean> = this.hideMenu.asObservable();

  @Output() aClickedEvent = new EventEmitter<any>();

  private subject = new Subject<any>();

  private subjectEnroll = new BehaviorSubject<boolean>(false);
  public subjectEnrollSteps: Observable<boolean> = this.subjectEnroll.asObservable();

  private multiStubIdSubject = new BehaviorSubject<boolean>(false);
  public multiStubIdSubjectSteps: Observable<boolean> = this.multiStubIdSubject.asObservable();

  cartItem: any;
  triggerUrl: any;
  user;

  constructor(
    private utilityService: UtilityService,
    private router: Router,
    private httpClientService: HttpClientService,
    private cms: CMSResolver,
    private authenticationService: AuthenticationService,
  ) {
    document.addEventListener('logoutCurrentUser', this.logoutCurrentUser);
    document.addEventListener('toggleAlertMenu', this.toggleAlertMenu);

    AuthenticationService.User$.subscribe(u => {
      this.user = u;
      this.initUser();
      // if (!this.authenticationService.isLoggedIn()) u = undefined;

    });
  }
  sendClickEvent() {
    this.subject.next();
  }
  getClickEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  AClicked(msg: string) {
    this.aClickedEvent.emit(msg);
  }

  initUser() {
    let u = this.user;
    console.dir(u);
    // if(u != undefined){
    //   if(u.userId == "Unauthenticated" || u.roles == "Unknown"){
    //     u = undefined;
    //   }
    // }
    if (u) {
      this.userLogin();
      this.setlogoutHeaderChanges(false);
    } else {
      this.setlogoutHeaderChanges(true);
      this.logoutUser();
    }
  }

  logoutCurrentUser(event) {
    let isConfirmPopup = event.isConfirmPopup;
    this.logoutHistoryCall();
    sessionStorage.clear();
    localStorage.clear();
    if (ENV_PORTAL.toUpperCase() == "DMPADMIN"){
      document.cookie = "attESSec=; expires="+ new Date(0).toUTCString() +"; path=/; domain=.att.com";
      document.cookie = "attESHr=; expires="+ new Date(0).toUTCString() +"; path=/; domain=.att.com";
      localStorage.setItem('adminLogout', 'true');
      // window.location.href = ADMIN_LOGOUT;
    }
    // location.reload();
    HeaderService.logoutHeaderChange();
    if (isConfirmPopup) {
      localStorage.setItem('sapmp_isAutoLogout', 'TRUE');
    }
    AuthenticationService.logoutStatic();
  }

  pageContent(datakey) {
    return this.cms.updateCMS(datakey);
  }

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }

  setCondensedFooterStatus(value: boolean) {
    this.pageStatus.next(value);
  }

  getCondensedFooterStatus(): Observable<boolean> {
    return this.obvStep;
  }

  setlogoutHeaderChanges(value: boolean) {
    this.logoutHeaderChanges.next(value);
  }

  getlogoutHeaderChanges(): Observable<boolean> {
    return this.logoutHeaderChangesSteps;
  }

  setHideMenu(value: boolean) {
    this.hideMenu.next(value);
  }

  getHideMenu(): Observable<boolean> {
    return this.hideMenuSteps;
  }

  condensedHeader(pageName) {
    if (pageName === 'checkout') {
      document.getElementById('hamNav').style.display = 'none';
      document.getElementById('userProfileInfo').style.display = 'none';
    } else {
      // document.getElementById('hamNav').style.display = 'inline-block';
      document.getElementById('userProfileInfo').style.display = 'inline-block';
    }
  }
  userLogin() {
    var elements = <HTMLCollectionOf<HTMLElement>>document.getElementsByClassName('loginBtn');
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.display = "none";
      elements[i].setAttribute("tabindex", "-1");
    }

    var elements = <HTMLCollectionOf<HTMLElement>>document.getElementsByClassName('logoutBtn');
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.display = "inline-block";
      elements[i].removeAttribute("tabindex");
    }
  }


  logoutUser() {
    HeaderService.logoutHeaderChange();
  }
  static logoutHeaderChange() {
    var elements = <HTMLCollectionOf<HTMLElement>>document.getElementsByClassName('logoutBtn');
    HeaderService.hideNotification();
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.display = "none";
      elements[i].setAttribute("tabindex", "-1");
    }

    var elements = <HTMLCollectionOf<HTMLElement>>document.getElementsByClassName('loginBtn');
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.display = "inline-block";
      elements[i].removeAttribute("tabindex");
    }
  }
  static hideNotification() {
    var upi = document.getElementById('userProfileInfo');
    if (!upi) return;
    upi.classList.remove('show');
    document.body.classList.remove('d-open');
    var hideNotification = sessionStorage.getItem('hideNotifications');
    if (hideNotification && hideNotification != 'true') {
      if (document.getElementById('alert-widget').innerHTML && document.getElementById('alert-widget').innerHTML != '') {
        document.getElementById('alert-widget').setAttribute('style', 'display: inline');
        document.getElementById('icon-log-out').setAttribute('style', 'margin-right: -10px');
      }
      document.getElementById('icon-log-out').setAttribute('style', 'display: inline');
      document.getElementById('icon-close-log-out').setAttribute('style', 'display: none');
    }
  }

  toggleAlertMenu(elem) {
    var alertBanner = document.getElementsByClassName('alert-banner')[0];
    var userprofile = document.getElementsByClassName('user-profile')[0];
    var profile = document.getElementsByClassName('profile')[0];
    if (alertBanner) {
      alertBanner.setAttribute('style', 'display:none');
    }
    document.getElementById('alert-widget').setAttribute('style', 'display: none');
    document.getElementById('icon-log-out').setAttribute('style', 'display: none');
    document.getElementById('icon-close-log-out').setAttribute('style', 'display: inline');
    sessionStorage.setItem('hideNotifications', 'false');
    //elem.parentElement.classList.toggle('active');
    userprofile.classList.toggle('show');
    profile.classList.toggle('active');
    document.body.classList.toggle('d-open');
    //if (!elem.parentElement.classList.contains('active')) {
    if (!userprofile.classList.contains('show')) {
      HeaderService.hideNotification();
    } else {
      let element = <HTMLElement>document.querySelectorAll(".logoutBtn")[0];
      element.focus();
    }
    //checkUserLog();
  }
  logoutDeleteSession() {
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('cart');
    sessionStorage.removeItem('sapmp_jwtToken');
    sessionStorage.removeItem('permissions');
    sessionStorage.removeItem('steps-checkout');
    sessionStorage.removeItem('steps-manageUsers');
    sessionStorage.removeItem('assign-wizard');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('hideNotifications');
    sessionStorage.removeItem('once');
  }

  sendEnrollClickEvent(value: boolean) {
    this.subjectEnroll.next(value);
  }
  getEnrollClickEvent(): Observable<boolean> {
    return this.subjectEnrollSteps;
  }

  sendMenuHideEvent(value: boolean) {
    this.multiStubIdSubject.next(value);
  }
  getMenuHideEvent(): Observable<boolean> {
    return this.multiStubIdSubjectSteps;
  }

  logoutHistoryCall(): void {
    let ivUser = sessionStorage.getItem('iv-user');
    let headers = new HttpHeaders();
    headers = headers.append('init', 'true');
    headers = headers.append('iv-user', ivUser);
    // headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    // headers = headers.append('Authorization', 'Basic '+PERMISSION[0]['basicAuth']);
    let url = this.utilityService.getEnvConfig().logoutHistory;
    this.httpClientService.get(url, headers).subscribe((resp: any) => {
        console.log('logout history success');
      });
  }

}
